import { defineComponent as _defineComponent } from 'vue'
import Toast from "@/components/workspace/layout/toast.vue";
import ToastLegacy from "@/plugins/toast.vue";
import ConfirmInline from "@/components/workspace/layout/confirm-inline.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,Toast, ToastLegacy, ConfirmInline }
}

})